import styled from "styled-components";

type Props = {
  title: string;
  children: React.ReactNode;
};

export const CardTemplate: React.FC<Props> = ({ title, children }) => {
  return (
    <StyledContentContainer>
      <StyledTitle>{title}</StyledTitle>
      <StyledContent>{children}</StyledContent>
    </StyledContentContainer>
  );
};

const StyledContentContainer = styled.div`
  @media (max-width: 990px) {
    width: 100%;
    max-width: 400px;
    padding: 32px 24px 40px 24px;
  }

  display: flex;
  flex-direction: column;
  width: 500px;
  background-color: #ffffff;
  padding: 48px 56px 56px 56px;
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1), 0 1px 4px rgba(0, 0, 0, 0.1);
`;

const StyledTitle = styled.h1`
  font-size: 32px;
  line-height: 48px;
  font-weight: 600;
  text-align: center;
  margin: 0 0 32px 0;
  color: #052659;

  @media (max-width: 990px) {
    font-size: 24px;
    line-height: 150%;
    margin-bottom: 24px;
  }
`;

const StyledContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0;
`;
